import styled from 'styled-components';
import { Button } from '@/components/UI/Button';
import { SearchInput } from '@/components/Pbl/CaseList/styles';
import { PreferredLawyerBadge } from './styles';

export const DirectoryDescription = styled.p`
  margin-bottom: 24px;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.6;
`;

export const DirectoryToolbar = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 24px;
`;

export const DirectoryField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  flex: 1 1 240px;
  max-width: 440px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.5;

  @media (max-width: 639px) {
    flex-basis: 100%;
    max-width: none;
  }
`;

export const DirectoryInput = styled(SearchInput)`
  width: 100%;
  min-width: 0;
  min-height: 44px;
  height: auto;
  padding: 10px 12px;
  border-color: ${(p) => p.theme.colors.gray300};

  &:focus-visible {
    outline-color: ${(p) => p.theme.colors.primary500};
  }
`;

export const DirectoryButton = styled(Button)`
  min-height: 44px;
  height: auto;
  padding: 10px 18px;
  white-space: normal;
  line-height: 1.4;
  overflow-wrap: anywhere;
  touch-action: manipulation;
`;

export const DirectoryPanel = styled.div`
  padding: 8px 28px;
  background: ${(p) => p.theme.colors.light};
  border-radius: ${(p) => p.theme.radii.lg};

  @media (max-width: 639px) {
    padding: 0 16px;
  }
`;

export const DirectoryList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const DirectoryRow = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 0;

  & + & {
    border-top: 1px solid ${(p) => p.theme.colors.gray100};
  }

  @media (max-width: 900px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
`;

export const DirectoryIdentity = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const DirectoryName = styled.h2`
  margin: 0;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  line-height: 1.5;
  overflow-wrap: anywhere;
`;

export const DirectoryBadge = styled(PreferredLawyerBadge)`
  margin: 0;
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.5;
`;

export const DirectoryActions = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 900px) {
    width: 100%;
    > button {
      flex: 1 1 160px;
    }
  }
`;

export const DirectoryState = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 16px;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.6;
  text-align: center;
`;

export const DirectoryPagination = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 0 8px;
  font-size: ${(p) => p.theme.fontSizes.base};
  font-variant-numeric: tabular-nums;
`;
